import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import RuntimePreview from "./RuntimePreview";

/**
 * The landing-page preview is an ephemeral local adaptation of the Windie
 * inspector. It deliberately owns its state so visitors can explore the
 * interface without touching a running Windie instance or a real database.
 */
export default function ProductPreview() {
  const [hasScrolledDown, setHasScrolledDown] = useState(false);

  useEffect(() => {
    let previousScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > previousScrollY) {
        setHasScrolledDown(true);
        window.removeEventListener("scroll", handleScroll);
      }
      previousScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section
      id="runtime"
      data-testid="product-preview"
      className="relative px-6 md:px-10 pt-8 md:pt-16 pb-16 md:pb-24"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={hasScrolledDown ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center md:col-span-12 md:col-start-1"
        >
          <h2 className="font-serif text-3xl leading-[1.05] tracking-tight md:text-4xl">
            See what your AI sees.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15% 0px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-12 md:col-start-1"
        >
          <RuntimePreview />
          <p className="mt-4 text-center font-mono text-[11px] tracking-[0.12em] text-ink-50">
            Preview. Select a model here; install Windie to query
          </p>
        </motion.div>
      </div>
    </section>
  );
}
